import Draw, { createBox } from 'ol/interaction/Draw.js';
import { Vector as VectorLayer } from 'ol/layer.js';
import { Vector as VectorSource } from 'ol/source.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import Feature from 'ol/Feature.js';
import Circle from 'ol/geom/Circle.js';
import Point from 'ol/geom/Point.js';
import { fromCircle } from 'ol/geom/Polygon.js';
import * as turf from '@turf/turf';


let draw; // interacción activa
let source = new VectorSource({ wrapX: false });
let vector;
let coords;
let radius;
let center;

source.on('addfeature', function (evt) {
  const feature = evt.feature;
  const geom = feature.getGeometry();
  const geomType = geom.getType();

  if (geomType === 'Point') {
    center = geom.getCoordinates();
    console.log("🟢 Centro actualizado:", center);
  } else if (geomType === 'Circle') {
    center = geom.getCenter();
    radius = geom.getRadius();
    console.log("🟢 Centro (desde círculo):", center, "Radio:", radius);
  } else {
    coords = geom.getCoordinates();
  }
});

export const geoprocessingsInteraction = {
  data() {
    return {
      message: 'Hola',
      lastGeometry: null,
    };
  },
  methods: {
    addGeoInteraction(drawType) {
      // 🧠 drawType puede venir como { name, code }
      const typeCode = typeof drawType === 'string' ? drawType : drawType.code;

      // ✅ limpia interacciones previas
      if (draw) this.map.removeInteraction(draw);
      if (!vector) {
        vector = new VectorLayer({ source });
        this.map.addLayer(vector);
      }

      let geometryFunction = undefined;

      // 🟥 caso especial: "Box" (rectángulo)
      if (typeCode === 'Box') {
        geometryFunction = createBox();
      }

      // ✅ soporta Polygon, Box y LineString
      draw = new Draw({
        source: source,
        type: geometryFunction ? 'Circle' : typeCode, // "Circle" usado como base para Box
        geometryFunction: geometryFunction,
      });

      draw.on('drawstart', function () {
        source.clear(); // limpiar anterior
      });

      draw.on('drawend', this.onDrawEnd);
      this.map.addInteraction(draw);

      console.log(`✏️ Iniciada interacción de dibujo: ${typeCode}`);
    },

    removeGeoInteraction() {
      if (vector) this.map.removeLayer(vector);
      if (draw) this.map.removeInteraction(draw);
      source.clear();
      draw = null;
      vector = null;
      coords = null;
      radius = null;
      center = null;
      this.lastGeometry = null;
    },

    cleanGeoDraw() {
      source.clear();
      coords = null;
      this.lastGeometry = null;
    },

    getPolygonCoords() {
      return coords;
    },
    getCircleRadius() {
      return radius;
    },
    getCenter() {
      return center;
    },

    getLastGeometryGeoJSON() {
      if (!this.lastGeometry) return null;
      const format = new GeoJSON();
      return format.writeGeometryObject(this.lastGeometry, {
        featureProjection: this.map.getView().getProjection(),
        dataProjection: 'EPSG:3857',
      });
    },

    onDrawEnd(evt) {
      const geometry = evt.feature.getGeometry();
      this.lastGeometry = geometry;

      // ✅ Standardized Geometry Payload
      const type = geometry.getType();
      const coordinates = geometry.getCoordinates();

      const inputGeometries = [{
        type: type,
        coordinates: coordinates
      }];

      const customGeometry = {
        input_geometries: inputGeometries
      };

      console.log("✅ Geometría capturada (Standardized):", customGeometry);

      // ✅ FIX: Asignar directamente a la variable del componente
      this.geoRequestData = customGeometry;

      this.executeMapToolAction('geoprocessing', 'ready', {
        geoRequestData: customGeometry,
      });
    },

    /**
     * Dibuja los anillos de influencia radial
     * @param {Array} distances - Array de distancias en metros
     */
    drawRings(distances) {
      if (!center) {
        console.warn("⚠️ No hay un punto central definido para dibujar anillos.");
        return;
      }

      console.log("✏️ Dibujando anillos para distancias (m):", distances);
      source.clear();

      // 1. Re-agregar el punto central
      const pointFeature = new Feature(new Point(center));
      source.addFeature(pointFeature);

      const inputGeometries = [];

      // 2. Agregar círculos
      distances.forEach((distM) => {
        const radiusMeters = distM;

        // OL Circle no es estándar GeoJSON, lo convertimos a Polígono aproximado
        const circleGeom = new Circle(center, radiusMeters);
        // Usamos fromCircle importado, o fallback a Polygon.fromCircle si fuera necesario
        const polygonGeom = fromCircle ? fromCircle(circleGeom) : Polygon.fromCircle(circleGeom);

        const circleFeature = new Feature(polygonGeom);
        source.addFeature(circleFeature);

        // Standardized payload data for Radial
        inputGeometries.push({
          type: "Polygon",
          coordinates: polygonGeom.getCoordinates(),
          radius: radiusMeters // Optional, valid for Radial
        });
      });

      // Construct the standardized custom geometry object
      const customGeometry = {
        input_geometries: inputGeometries,
        // type can be inferred from context or sent separately. 
        // Here we just prepare data structure.
      };

      console.log("📦 [DEBUG] Custom Geometry Payload (Standardized):", customGeometry);

      // ✅ FIX: Asignar directamente
      this.geoRequestData = customGeometry;

      this.executeMapToolAction("geoprocessing", "ready", {
        geoRequestData: customGeometry,
      });
    },
  },
};
